export const FETCHING_GALLERY = 'FETCHING_GALLERY';
export const FETCHING_GALLERY_FAILED = 'FETCHING_GALLERY_FAILED';
export const FETCHING_GALLERY_SUCCESS = 'FETCHING_GALLERY_SUCCESS';
